import { initElmApp } from 'elm/utilities'
import * as GeoMapContainer from 'elm/src/GeoMapContainer.elm'
import { GeoMap } from 'visualizations/geo-map'
import { ImageStore } from 'visualizations/image-store'

export function init (): null {
  const app = initElmApp(GeoMapContainer)
  const targetContainer = document.getElementById('geo_map') as HTMLElement

  app.ports.render.subscribe((data: any) => {
    const blobIds = data.nodes.map(n => n.blobId)
    const imageStore = new ImageStore(data.settings.depotId, blobIds)
    const geoMap = new GeoMap(targetContainer, data.settings, data.nodes, imageStore)

    geoMap.on('click', nodeId => app.ports.nodeClicked.send(nodeId))
    geoMap.on('unclick', () => { layoverController().clear() })
  })

  app.ports.openCard.subscribe((nodeId: string) => {
    layoverController().load(nodeId, 'card')
  })
}

const layoverController = (): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
}
